import { createFileRoute } from '@tanstack/react-router';
import { CompanyPage } from '@/pages/company/company-page.tsx';

export const Route = createFileRoute('/_auth/unternehmen/')({
  component: RouteComponent,
  staticData: { title: 'Unternehmen' },
});

function RouteComponent() {
  return <CompanyPage />;
}
